import React from 'react'
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Button,
  Chip,
} from '@mui/material'
import {
  FilterList as FilterIcon,
  Clear as ClearIcon,
} from '@mui/icons-material'

const AnalyticsFilters = ({ 
  filters, 
  availableFilters, 
  onFilterChange, 
  isAdmin 
}) => {
  const handleFilterChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: value,
    })
  }

  const handleClearFilters = () => {
    onFilterChange({
      ticket_type: '',
      created_by: '',
      date_from: '',
      date_to: '',
    })
  }

  const hasActiveFilters = Object.values(filters).some(value => value !== '' && value !== null)

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <FilterIcon sx={{ mr: 1 }} />
        <Typography variant="h6">
          Filters
        </Typography>
        {hasActiveFilters && (
          <Button
            startIcon={<ClearIcon />}
            onClick={handleClearFilters}
            size="small"
            sx={{ ml: 2 }}
          >
            Clear All
          </Button>
        )}
      </Box>

      <Grid container spacing={3}>
        {/* Ticket Type Filter */}
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Ticket Type</InputLabel>
            <Select
              value={filters.ticket_type || ''}
              onChange={(e) => handleFilterChange('ticket_type', e.target.value)}
              label="Ticket Type"
            >
              <MenuItem value="">
                <em>All Types</em>
              </MenuItem>
              {availableFilters.ticket_types.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Created By Filter - Only show for admin users */}
        {isAdmin && (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Created By</InputLabel>
              <Select
                value={filters.created_by || ''}
                onChange={(e) => handleFilterChange('created_by', e.target.value)}
                label="Created By"
              >
                <MenuItem value="">
                  <em>All Users</em>
                </MenuItem>
                {availableFilters.created_by_users.map((user) => (
                  <MenuItem key={user} value={user}>
                    {user}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* Date From Filter */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="From Date"
            type="date"
            value={filters.date_from || ''}
            onChange={(e) => handleFilterChange('date_from', e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        {/* Date To Filter */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="To Date"
            type="date"
            value={filters.date_to || ''}
            onChange={(e) => handleFilterChange('date_to', e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Active Filters:
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {filters.ticket_type && (
              <Chip
                label={`Type: ${filters.ticket_type}`}
                onDelete={() => handleFilterChange('ticket_type', '')}
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
            {filters.created_by && isAdmin && (
              <Chip
                label={`Created by: ${filters.created_by}`}
                onDelete={() => handleFilterChange('created_by', '')}
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
            {filters.date_from && (
              <Chip
                label={`From: ${filters.date_from}`}
                onDelete={() => handleFilterChange('date_from', '')}
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
            {filters.date_to && (
              <Chip
                label={`To: ${filters.date_to}`}
                onDelete={() => handleFilterChange('date_to', '')}
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
          </Box>
        </Box>
      )}

      {/* User Role Indicator */}
      {!isAdmin && (
        <Box sx={{ mt: 2 }}>
          <Chip
            label="Viewing your tickets only"
            size="small"
            color="info"
            variant="outlined"
          />
        </Box>
      )}
    </Box>
  )
}

export default AnalyticsFilters